import { Button, Form, type Job, TraitementLong } from '@mairistem/composants';
import { getErrorMessage } from '@mairistem/finances-utils';
import { downloadFile } from '@mairistem/tools';
import React from 'react';
import { toast } from 'react-toastify';
import type ExportExcelValues from '../../../../interfaces/simulation/exportExcelValues';
import type OutilModalProps from '../../../../interfaces/simulation/outilModalProps';
import { getExportExcel } from '../../../../services/simulation/simulation';

const ExportExcel = ({ simulation }: Pick<OutilModalProps, 'simulation'>) => {
	const [loading, setLoading] = React.useState<boolean>(false);
	const [job, setJob] = React.useState<Job>();

	const [values, setValues] = React.useState<ExportExcelValues>({
		wantYearMinusOne: false,
		wantYearMinusTwo: false,
	});

	const handleChange = (
		_e,
		{ checked, name }: { checked: boolean; name: string },
	) => {
		setValues((old) => ({
			...old,
			[name]: checked,
		}));
	};

	const handleExport = async () => {
		try {
			setLoading(true);
			const newJob = await getExportExcel(simulation.identifiant, values);
			setJob(newJob);
		} catch (e) {
			toast.error(getErrorMessage(e, "Erreur lors de l'export"));
			setLoading(false);
		}
	};

	const handleCloseJob = async (finishedJob: Job) => {
		setJob(null);
		setLoading(false);

		if (finishedJob.status === 1) {
			await downloadFile(finishedJob.identifiant);
		} else {
			toast.error(finishedJob.resultat);
		}
	};

	const handleJobError = () => {
		setJob(null);
		setLoading(false);
		toast.error('Erreur lors du traitement');
	};

	return (
		<>
			<Form>
				{`Pour les exercices antérieurs, seules les lignes budgétaires
          ayant une correspondance avec les lignes de l’exercice courant sont comptabilisées.`}
				<Form.Group grouped>
					<Form.Checkbox
						checked={values.wantYearMinusTwo}
						data-testid="yearMinusTwoCheckbox"
						label={`Données ${simulation.exercice.anneeExercice - 2}`}
						name="wantYearMinusTwo"
						onChange={handleChange}
						toggle
					/>
					<Form.Checkbox
						checked={values.wantYearMinusOne}
						data-testid="yearMinusOneCheckbox"
						label={`Données ${simulation.exercice.anneeExercice - 1}`}
						name="wantYearMinusOne"
						onChange={handleChange}
						toggle
					/>
					<Form.Checkbox
						checked
						disabled
						label={`Données ${simulation.exercice.anneeExercice}`}
						toggle
					/>
				</Form.Group>
			</Form>
			<div>
				<Button
					content="Exporter le fichier"
					data-testid="exportButton"
					disabled={loading}
					floated="right"
					loading={loading}
					onClick={handleExport}
					positive
				/>
			</div>

			{loading && job && (
				<TraitementLong
					title="Exportation des données vers Excel"
					identifiantJob={job?.identifiant}
					onFinish={handleCloseJob}
					onError={handleJobError}
					indeterminate
				/>
			)}
		</>
	);
};

export default ExportExcel;
